module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-Medium.205cc78.woff";